import { ConfigProvider } from 'antd'
import { createContext, useContext, useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { updateTranslations } from '../i18n'

const FALLBACK_THEME = {
  colorPrimary: '#DA2BB8',
  colorPrimaryHover: '#00A3D7',
  borderRadius: '2px',
  colorLink: '#DA2BB8',
  colorLinkHover: '#00A3D7',
  colorLinkActive: '#00A3D7',
  controlHeight: '50',
  controlInteractiveSize: '24px',
  logo: 'http://openpublishing.com/wp-content/uploads/2023/03/OPSH_Logo_RGB_72dpi_RZ.png',
  logoHeight: '42px',
  registerPolicyCheckbox: false,
  colorTextBase: '#333',
}

const CustomisationContext = createContext({})

export const useCustomisation = () => {
  return useContext(CustomisationContext)
}

const ACCOUNTCONFIG = 'account.json'
const CONTEXTCONFIG = 'context.json'

export const CustomisationProvider = ({ children }) => {
  const redirectUri = getRedirectUri()
  const [loading, setLoading] = useState(true)
  const [theme, setTheme] = useState(FALLBACK_THEME)
  const [realm, setRealm] = useState()
  const [apiHost, setApiHost] = useState()

  const fetchConfig = async (name) => {
    const response = await fetch('/config/' + name)
    if (!response.ok) {
      throw new Error(
        `Fetch error for ${name}: ${response.status} ${response.statusText}`
      )
    }
    return response.json()
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const contextConfig = await fetchConfig(CONTEXTCONFIG)
        setApiHost(contextConfig.api_host)
        setRealm(contextConfig.realm_name)
      } catch (error) {
        console.error(error)
      }

      try {
        const accountConfig = await fetchConfig(ACCOUNTCONFIG)
        if (accountConfig) {
          setTheme((prevTheme) => ({ ...prevTheme, ...accountConfig }))
          if (accountConfig?.translations?.de) {
            updateTranslations(accountConfig['translations'])
          }
        }
      } catch (error) {
        console.error(error)
      }
      setLoading(false)
    }
    fetchData()
  }, [])

  const value = { loading, apiHost, realm, redirectUri, theme }
  // make theme colors available in css
  const styles = `body {
    --colorPrimary: ${theme.colorPrimary};
    --loginBGImage: ${theme.loginBGImage};
    --colorPrimaryHover: ${theme.colorPrimaryHover} }`
  return (
    <CustomisationContext.Provider value={value}>
      <style>{styles}</style>
      <ConfigProvider theme={{ token: theme }}>{children}</ConfigProvider>
    </CustomisationContext.Provider>
  )

  function getRedirectUri() {
    const [searchParams] = useSearchParams()
    const redirectUriParam = searchParams.get('redirect_uri')
    return decodeURIComponent(redirectUriParam || '')
  }
}
